import React from 'react';

interface useIntercomToolsHook {

    /* Method to call specific experiences */
    message( message: string ): void,
}

export const message: useIntercomToolsHook['message'] = ( message ) => {

    try{

        // @ts-ignore
        const Intercom = window.Intercom;

        if( Intercom ){

            Intercom( 'showNewMessage', message )
        }

    } catch( e ) {

        // ..
        console.warn( 'Intercom is not available' );
        console.warn( e.message );
    }
}

export const useIntercomTools = (): useIntercomToolsHook => {

    return {
        message,
    }
};
